import React, { useState, useEffect } from "react";
import { useBooking } from "../context/BookingContext";
import { schedulerLink } from "./blocks";
import { SCHEDULER_URL } from "../data/content";

export function StickyCTA({ interest = "Sales", label = "Book a free discovery call", utm, onClick, variant = "pill", text, href }) {
  const { openBooking } = useBooking();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (variant === "bar") {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        setShow(scrollable > 0 && window.scrollY / scrollable > 0.25);
      } else {
        setShow(window.scrollY > 700);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [variant]);

  // Slim single-line bar (bottom of viewport). Text on the left (hidden on mobile so the
  // transcript stays the focus), ember button on the right (full-width on mobile).
  if (variant === "bar") {
    return (
      <div
        className={`fixed inset-x-0 bottom-0 z-40 transition-all duration-300 ${
          show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full pointer-events-none"
        }`}
        data-testid="sticky-cta-bar"
      >
        <div className="bg-surface/95 backdrop-blur-md border-t border-white/10 shadow-[0_-8px_30px_rgba(0,0,0,0.45)]">
          <div className="max-w-6xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
            {text && <p className="hidden sm:block text-white text-sm font-medium truncate" data-testid="sticky-cta-text">{text}</p>}
            <a
              href={href}
              data-testid="sticky-cta"
              className="shrink-0 w-full sm:w-auto text-center bg-ember hover:bg-ember/90 text-white font-eyebrow uppercase tracking-[0.16em] text-[11px] px-7 py-3 rounded-full shadow-[0_12px_40px_rgba(204,65,0,0.45)] transition-colors"
            >
              {label}
            </a>
          </div>
        </div>
      </div>
    );
  }

  const cls =
    "pointer-events-auto block w-full max-w-md mx-auto md:w-auto md:mx-0 md:px-8 bg-ember hover:bg-ember/90 text-white font-eyebrow uppercase tracking-[0.16em] text-[11px] py-4 rounded-full text-center shadow-[0_12px_40px_rgba(204,65,0,0.45)] transition-colors";

  return (
    <div
      className={`fixed z-40 pointer-events-none transition-all duration-300 inset-x-0 bottom-0 px-4 pb-4 md:inset-x-auto md:right-6 md:bottom-6 md:px-0 md:pb-0 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
    >
      {onClick ? (
        <button onClick={onClick} data-testid="sticky-cta" className={cls}>
          {label}
        </button>
      ) : SCHEDULER_URL ? (
        <a href={schedulerLink(utm)} target="_blank" rel="noreferrer" data-testid="sticky-cta" className={cls}>
          {label}
        </a>
      ) : (
        <button onClick={() => openBooking(interest)} data-testid="sticky-cta" className={cls}>
          {label}
        </button>
      )}
    </div>
  );
}
